/*
 * <pdp-read-more> — clamp a block of content behind a "read more" button.
 *
 * Markup owns the clamp (Tailwind classes on [data-read-more-content] keyed off
 * the host's [expanded] attribute), so the breakpoint and height live in Liquid.
 * This element only:
 *   - shows [data-read-more-toggle] when the content actually overflows the clamp
 *     (short content, or a breakpoint with no clamp, never gets a dead button)
 *   - sets [expanded] on click, then removes the button (expand-only, per design)
 *
 * A custom element, not a DOMContentLoaded script: the PDP buy box is swapped in
 * from DOMParser on variant change, and adopted markup never runs inline scripts.
 */
class PdpReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector("[data-read-more-content]");
    this.toggle = this.querySelector("[data-read-more-toggle]");
    if (!this.content || !this.toggle) return;

    this._onClick = () => {
      this.setAttribute("expanded", "");
      this.toggle.hidden = true;
      this._observer?.disconnect();
    };
    this.toggle.addEventListener("click", this._onClick);

    this._observer = new ResizeObserver(() => this._check());
    this._observer.observe(this.content);
    this._check();
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    this.toggle?.removeEventListener("click", this._onClick);
  }

  _check() {
    if (this.hasAttribute("expanded")) return;
    const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
    this.toggle.hidden = !overflowing;
    this.toggleAttribute("overflowing", overflowing);
  }
}

if (!customElements.get("pdp-read-more")) {
  customElements.define("pdp-read-more", PdpReadMore);
}
